export default __webpack_public_path__ + "static/media/google-app-store.33ae7091.png";